import { SCREENING_CODES } from "~/common/utils/consultations/screening";
import { ScoresData } from "~/providers/utils/types/patientPreviewTypes";
import { SummaryVersion } from "~/providers/utils/types/SummariesVersionsTypes";
import { SelfReportedScoresCard } from "./SelfReportedScoresCard";

interface PatientPreviewSelfReportedScoresProps {
  scores: ScoresData;
  version?: SummaryVersion;
}

export const PatientPreviewSelfReportedScores = ({
  scores,
  version,
}: PatientPreviewSelfReportedScoresProps) => {
  const { phq9, gad7, asrs } = scores;

  return (
    <div className="flex flex-col gap-3 sm:flex-row">
      <SelfReportedScoresCard
        scoreData={phq9}
        code={SCREENING_CODES.phq9}
        version={version}
      />
      <SelfReportedScoresCard
        scoreData={gad7}
        code={SCREENING_CODES.gad7}
        version={version}
      />
      <SelfReportedScoresCard
        scoreData={asrs}
        code={SCREENING_CODES.asrs}
        version={version}
      />
    </div>
  );
};
